const { resetPersonalizationForm } = require("./liquidSDKHelpers");
const { calculateDistance } = require("coremh/components/calculateDistance");

const $citySuggestionsContainer = $("#citySuggestionsContainer");
const $suggestionsList = $("#citySuggestionsList");
const $personalizationInputText = $("#personalizationText");
const $previewText = $(".js-preview-text");
const $personalizationForm = $(".js-personalization-form");
const $liquidPersonalizationModal = $("#liquidPersonalizationModal");
const $liquidPersonalizationBtn = $(".js-liquid-personalization");
const $intervals = $(".js-intervals");
const reimsCoordinates = {
    lat:49.2597854,
    lng:4.0322026
};

let placeId = "";

/**
* Validates if the input value contains only alphanumeric characters and spaces.
*
* @param {string} value - The input value to be validated.
* @returns {boolean} - Returns true if the input is valid, otherwise false.
*/
function isAlphanumericInput(value) {
    const regex = /^[a-zA-Z0-9\s]*$/;
    return regex.test(value);
}

/**
* Validates the input field to ensure it contains only alphanumeric characters and spaces.
* If the input contains non-alphanumeric characters, they are removed.
*
* @param {jQuery} $input - The jQuery object representing the input field to be validated.
*/
function validateInput($input) {
    const value = $input.val();
    if (!isAlphanumericInput(value)) {
        $input.val(value.replace(/[^a-zA-Z0-9\s]/g, ""));
    }
}

/**
* Updates the display text element with the value from the input text element if the input is alphanumeric.
*
* @param {jQuery} $inputText - jQuery object representing the input text element.
* @param {jQuery} $displayText - jQuery object representing the display text element.
*/
function updateDisplayText($inputText, $displayText) {
    var $inputValue = $inputText.val();

    if (isAlphanumericInput($inputValue)) {
        $displayText.text($inputValue);
    }
}

/**
* Adds CSS classes to a container element based on the length of the input text.
*
* This function evaluates the number of characters in the input text and assigns
* a corresponding CSS class to the container element to reflect different intervals
* of text length.
*
* @param {jQuery} $inputText - jQuery object representing the input text element.
* @param {jQuery} $container - jQuery object representing the container element to which classes will be added.
*/
function addIntervalClasses($inputText, $container) {
    var numChars = $inputText.val().length;

    $container.removeClass("interval1 interval2 interval3 interval4");

    if (numChars >= 1 && numChars <= 10) {
        $container.addClass("interval1");
    } else if (numChars >= 11 && numChars <= 14) {
        $container.addClass("interval2");
    } else if (numChars >= 15 && numChars <= 17) {
        $container.addClass("interval3");
    } else if (numChars >= 18 && numChars <= 21) {
        $container.addClass("interval4");
    }
}

/**
* Toggles the "has-value" class on an input element based on its value.
*
* If the input element has a non-empty value after trimming whitespace,
* the "has-value" class is added. Otherwise, the class is removed.
*
* @param {jQuery} $inputText - The jQuery object representing the input element.
*/
function toggleInputClass($inputText) {
    if ($inputText.val().trim() !== "") {
        $inputText.addClass("has-value");
    } else {
        $inputText.removeClass("has-value");
    }
}

/**
* Toggles the state of an element based on the input text value.
*
* This function checks if the input text value is non-empty and alphanumeric.
* If both conditions are met, it removes the specified class from the element.
* Otherwise, it adds the specified class to the element.
*
* @param {jQuery} $inputText - jQuery object representing the input text element.
* @param {jQuery} $element - jQuery object representing the element whose state is to be toggled.
* @param {string} toggledClass - The class to be toggled on the element.
*/
function toggleElementState($inputText, $element, toggledClass) {
    if (($inputText.val().trim() !== "") && isAlphanumericInput($inputText.val())) {
        $element.removeClass(toggledClass);
    } else {
        $element.addClass(toggledClass);
    }
}

/**
* Renders city details into a list of suggestions.
*
* This function clears any existing suggestions in the city suggestions list,
* then iterates over the provided city details to create and append new list
* items for each city.
*
* @param {Array<Object>} cityDetails - An array of city detail objects.
* @param {string} cityDetails[].description - The description of the city.
* @param {string} cityDetails[].place_id - The unique identifier for the city.
* @param {string} cityDetails[].main_text - The main text representing the city name.
*/
function renderCityDetails(cityDetails) {
    const $loaderLabel = $(".js-suggestion-loader");
    // Clear any existing suggestions
    // $suggestionsList is $("#citySuggestionsList") declared at the top
    $suggestionsList.empty();

    // show hide the loader label
    if (cityDetails.length) {
        $loaderLabel.addClass("d-none");
    } else {
        $loaderLabel.removeClass("d-none");
    }

    // Iterate over the city details and create <li> elements
    cityDetails.forEach(function(city) {
        var $li = $("<li></li>").text(city.description);
        $li.attr("data-place-id", city.place_id);
        $li.attr("data-city-name", city.main_text);
        $li.addClass("suggestions-item");
        $suggestionsList.append($li);
    });
}

/**
* Retrieves city suggestions based on the input text using Google Maps Places AutocompleteService.
*
* @param {string} inputText - The text input for which city suggestions are to be retrieved.
* @returns {void} This function does not return a value. It processes and renders city details.
*
* @example
* getCitySuggestions("San");
* // This will fetch and render city suggestions for the input 'San'.
*
* @see {@link https://developers.google.com/maps/documentation/javascript/reference/places-autocomplete-service|Google Maps AutocompleteService}
*/
function getCitySuggestions(inputText) {
    var autocompleteService = new google.maps.places.AutocompleteService();
    var cityDetails = [];
    var displaySuggestions = function(predictions, status) {
        if (status !== google.maps.places.PlacesServiceStatus.OK) {
            // show the error state on the form
            $personalizationForm.addClass("js-error-state");
            return cityDetails;
        }

        predictions.forEach(function(prediction) {
            cityDetails.push({
                "main_text": prediction.structured_formatting.main_text,
                "description": prediction.description,
                "place_id": prediction.place_id,
            });
        });

        // Hide the error state on the form
        $personalizationForm.removeClass("js-error-state");

        renderCityDetails(cityDetails); // Call the new function to render the city details

        return cityDetails;
    };

    autocompleteService.getPlacePredictions({
        input: inputText,
        types: ["(cities)"]
    }, displaySuggestions);
}

/**
* Retrieves the geographical coordinates (latitude and longitude) for a given place ID using the Google Maps Places Service.
*
* @param {string} placeId - The unique identifier for the place to retrieve details for.
* @param {function} callback - A callback function to handle the response.
* It takes two arguments: an error object (or null if no error) and a coordinates object containing `lat` and `lng` properties.
*
* @returns {void}
*
* @example
* getCoordinates('ChIJN1t_tDeuEmsRUsoyG83frY4', function(error, coordinates) {
*     if (error) {
*         console.error(error);
*     } else {
*         console.log('Latitude:', coordinates.lat, 'Longitude:', coordinates.lng);
*     }
* });
*/
function getCoordinates(placeId, callback) {
    var placesService = new google.maps.places.PlacesService(document.createElement("div"));
    placesService.getDetails({ placeId: placeId }, function(place, status) {
        if (status === google.maps.places.PlacesServiceStatus.OK) {
            if (place.geometry && place.geometry.location) {
                const coordinates = {
                    lat: place.geometry.location.lat(),
                    lng: place.geometry.location.lng()
                };
                callback(null, coordinates);
            } else {
                callback(new Error("No geometry information available for this place ID."));
            }
        } else {
            callback(new Error("Failed to get place details: " + status));
        }
    });
}

/**
* Toggles the visibility of various elements related to personalization content and forms.
* This function adds or removes the 'd-none' class to show or hide elements with specific classes.
*/
function toggleVisibilityClasses() {
    $(".js-personalization-content").toggleClass("d-none");
    $personalizationForm.toggleClass("d-none");
    $(".js-content-back").toggleClass("d-none");
    $(".js-personalization-back").toggleClass("d-none");
}

/**
* Trims the given city name to the maximum allowed length.
* @param {string} cityName - The name of the city to be trimmed.
* @returns {string} The trimmed city name.
*/
function trimCityName(cityName) {
    const maxLength = $personalizationInputText.attr("maxLength");

    return cityName.substring(0, maxLength);
}

/**
* Handles the 'Enter' key event on an input field to select a city suggestion.
* If the 'Enter' key is pressed, it prevents the default action, selects the first suggestion
* from the list, updates the input field and preview text with the selected city name, hides the
* suggestions container, and sets the place ID.
*
* @param {Event} e - The keydown event object.
*/
function onEnter(e) {
    if (e.key === "Enter") {
        e.preventDefault();
        const firstSuggestion = $suggestionsList.find("li").first();
        if (firstSuggestion.length) {
            const cityName = trimCityName(firstSuggestion.attr("data-city-name"));
            $(this).val(cityName);
            $previewText.text(cityName);
            $citySuggestionsContainer.addClass("d-none");
            placeId = firstSuggestion.attr("data-place-id");
            addIntervalClasses($personalizationInputText, $intervals);
        }
    }
}

/**
* Handles the click event on a suggestion item, updating the personalization input and preview text with the selected city name.
* Also sets the placeId based on the clicked suggestion's data attribute.
*
* @function
* @returns {void}
*/
function onSuggestionClick() {
    const $this = $(this);
    const cityName = trimCityName($this.attr("data-city-name"));
    $personalizationInputText.val(cityName);
    $previewText.text(cityName);
    placeId = $this.attr("data-place-id");
    addIntervalClasses($personalizationInputText, $intervals);
}

/**
* Event handler for calculating the distance between Reims and a target location.
* Prevents the default form submission behavior, retrieves the coordinates for Reims,
* and then calculates the distance to the target location.
*
* @param {Event} e - The event object associated with the form submission.
*/
function onCalculateDistance (e) {
    e.preventDefault();

    // Get the coordinates for Reims
    getCoordinates(placeId, function(err, coordinates) {
        if (err) {
            console.error(err);
        } else {
            // Get the coordinates for the target location
            calculateDistance(reimsCoordinates, coordinates, { updatePreview: true });
        }
    });
}

/**
* Toggles the visibility of city suggestions based on the input field's value and modal state.
*
* @param {Event} event - The event object triggered by the input field.
*/
function toggleSuggestions(event) {
    if ($liquidPersonalizationModal.hasClass("show")) {
        // if the target is the input field and it has something in it, show the suggestions
        if (event.target.id === "personalizationText" && event.target.value.length > 0) {
            $citySuggestionsContainer.removeClass("d-none");
        } else {
            $citySuggestionsContainer.addClass("d-none");
        }
    }
}


/**
* Handles the actions to be performed when the personalization modal is opened.
*/
function onModalOpen() {
    // disable the personalization button
    $liquidPersonalizationBtn.addClass("disabled");
    $liquidPersonalizationBtn.find(".liquid-loading").removeClass("d-none");
}


/**
* Handles the actions to be performed when the personalization modal is closed.
*/
function onModalClose() {
    // enable the personalization button
    $liquidPersonalizationBtn.removeClass("disabled");
    $liquidPersonalizationBtn.find(".liquid-loading").addClass("d-none");
    // reset the form
    resetPersonalizationForm();
}

function init() {
    const $personalizationSubmit = $("#personalizationSubmit");

    /**
    * Handles the 'input' event on the personalization input text field.
    *
    * This function performs several actions when the user types into the personalization input text field:
    * 1. Validates the input.
    * 2. Updates the display text.
    * 3. Adds interval classes to the preview text wrapper.
    * 4. Toggles the input class.
    * 5. Toggles the state of the submit button and city suggestions container.
    * 6. Fetches city suggestions based on the current input value.
    *
    * @param {jQuery} $personalizationInputText - The jQuery object representing the personalization input text field.
    */
    $personalizationInputText.on("input", function () {
        const $this = $(this);

        validateInput($this);
        updateDisplayText($this, $previewText);
        addIntervalClasses($this, $intervals);
        toggleInputClass($this);
        toggleElementState($this, $personalizationSubmit, "disabled");
        toggleElementState($this, $citySuggestionsContainer, "d-none");
        getCitySuggestions($this.val());
    });

    // when the user presses the enter key, select the first suggestion
    $personalizationInputText.on("keydown", onEnter);

    $personalizationInputText.on("focus", toggleSuggestions);

    $("body").on("click", toggleSuggestions);

    // when the user clicks on a suggestion, update the input text and hide the suggestions
    $suggestionsList.on("click", "li", onSuggestionClick);

    // when the user clicks on the submit button, calculate the distance
    $personalizationSubmit.on("click", onCalculateDistance);

    $(".js-content-back").on("click", toggleVisibilityClasses);

    // when the popup is shown, disable the personalization button
    $liquidPersonalizationModal.on("shown.bs.modal", onModalOpen);

    // when modal is closed, enable the personalization button
    $liquidPersonalizationModal.on("hidden.bs.modal", onModalClose);
}

export default () => {
    init();
};

